import React, { useMemo } from 'react'
import {
  Box,
  Tooltip,
  Checkbox,
  Typography,
  FormControl,
  FormHelperText,
  FormControlLabel,
} from '@mui/material'

export const CommonCheckbox = ({
  id,
  label,
  value,
  error,
  helperText,
  required,
  setValue,
  onChange,
  tooltip,
  stopNavigation = true,
  labelPlacement = undefined,
  onClick,
  ...muiProps
}) => {
  const handleChange = newValue => {
    if (setValue) setValue(newValue)
    if (onChange) onChange(newValue)
  }

  const labelWithAsterisk = useMemo(() => {
    if (required) {
      return (
        <Typography variant='body2'>
          {label}
          <span style={{ color: 'red', marginLeft: '2px' }}>*</span>
        </Typography>
      )
    }
    return <Typography variant='body2'>{label}</Typography>
  }, [label, required])

  return (
    <Box id={id} data-testid={id}>
      <FormControl error={!!error} {...muiProps}>
        <Tooltip id={id} title={tooltip || ''} placement='top' arrow>
          <FormControlLabel
            control={
              <Checkbox
                id={id}
                checked={!!value}
                onChange={e => handleChange(e.target.checked)}
                onClick={e => {
                  if (stopNavigation) e.stopPropagation()
                  if (onClick) onClick(e)
                }}
              />
            }
            label={labelWithAsterisk}
            labelPlacement={labelPlacement}
            sx={{ marginRight: '0px' }}
          />
        </Tooltip>

        {(error || helperText) && (
          <FormHelperText>{error || helperText}</FormHelperText>
        )}
      </FormControl>
    </Box>
  )
}
